import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const IconRefresh = ({
  title = "Refresh",
  color = "black",
  viewBoxWidth = 24,
  viewBoxHeight = 24,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon
    {...{
      title,
      viewBoxHeight,
      viewBoxWidth,
      strokeWidth: "2",
      fill: "none",
      stroke: uiColorToBaseColor(color),
      ...otherProps,
    }}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
    />
  </Svg.Icon>
)

export default IconRefresh
